import { openComposeWithViewState } from './openCompose';
import { getStore } from '../store/composeStore';
import ComposeTarget from '../store/schema/ComposeTarget';
import { moveComposeToPopoutActionName } from 'owa-mail-compose-action-names';
import { findTabByData, lazyCloseTab } from 'owa-tab-store';
import { action } from 'satcheljs/lib/legacy';
export default action(moveComposeToPopoutActionName)(function moveComposeToPopout(viewState, popoutSource) {
    // Close the existing compose.
    var state = getStore();
    if (state.defaultViewState == viewState) {
        state.defaultViewState = null;
    }
    else {
        var tab = findTabByData(viewState);
        if (tab) {
            lazyCloseTab.importAndExecute(tab, true /*forceClose*/);
        }
    }
    // Open this same compose in Popout
    openComposeWithViewState(viewState, ComposeTarget.Popout, popoutSource);
});
//# sourceMappingURL=moveComposeToPopout.js.map